/* eslint-disable multiline-ternary */
import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'

const CardProduct = (props) => {
  const { inverse, icon, children, imgSrc = '', image, config, imgAlt } = props

  return (
    <div className={resolveProps(props, config, 'CardProduct')}>
      {!!imgSrc && imgSrc ? (
        <div className="mdn-CardProduct-image">
          <img src={imgSrc} alt={imgAlt} />
        </div>
      ) : (
        ''
      )}
      <div className="mdn-CardProduct-content">{children}</div>
    </div>
  )
}

export default CardProduct

CardProduct.propTypes = {
  inverse: PropTypes.bool,
  image: PropTypes.bool,
  imgSrc: PropTypes.string,
  imgAlt: PropTypes.string
}
